import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUniqueNeighbourhoods } from "../store/propertiesSelectors";

interface NeighbourhoodInputProps {
  value: string;
  onChange: (neighbourhood: string) => void;
  disabled?: boolean;
  size?: "small" | "medium";
}

export const NeighbourhoodInput: React.FC<NeighbourhoodInputProps> = ({
  value,
  onChange,
  disabled = false,
  size = "medium",
}) => {
  const neighbourhoods = useSelector(selectUniqueNeighbourhoods);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      margin="dense"
      label="Neighbourhood"
      fullWidth
      size={size}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      select
      data-testid="neighbourhood-input"
    >
      <MenuItem value="">
        <em>All neighbourhoods</em>
      </MenuItem>
      {neighbourhoods.map((neighbourhood) => (
        <MenuItem key={neighbourhood} value={neighbourhood}>
          {neighbourhood}
        </MenuItem>
      ))}
    </TextField>
  );
};